// mixin-bc
import { vue3dLoader } from 'vue-3d-loader'

export default {
	data() {
		const axis = {
			x: 0,
			y: 0,
			z: 0
		};
		return {
			scale: {
				x: 0.5,
				y: 0.5,
				z: 0.5
			},
			dragging: true,
			filePath: '/3dfiles/booksample.glb',
			initialData: {
				objectPosition: JSON.parse(JSON.stringify(axis)),
				objectRotation: JSON.parse(JSON.stringify(axis)),
				cameraPosition: JSON.parse(JSON.stringify(axis)),
				cameraRotation: JSON.parse(JSON.stringify(axis))
			},
			dynamicData: {
				objectPosition: JSON.parse(JSON.stringify(axis)),
				objectRotation: JSON.parse(JSON.stringify(axis)),
				cameraPosition: JSON.parse(JSON.stringify(axis)),
				cameraRotation: JSON.parse(JSON.stringify(axis))
			},
			enableRotate: false,
			mousePosition: {
				x: null,
				y: null
			},
			enableDamping: true,
			dampingFactor: 0.005,
			backgroundAlpha: 0,
			backgroundColor: 'rgba(0, 0, 0, 0)'
		}
	},
	mounted() {
		if (this.hasTdModel) {
			let lastPercentage = 0;
			const viewHeight = window.innerHeight;
			const typeHeight = this.$el.offsetHeight;
			const threshold = new Array(101).fill(1).map((v, i) => i / 100);
			const observer = new IntersectionObserver(entries => {
				let { y, top } = entries[0].boundingClientRect;
				let percentage = top >= viewHeight ? 0 : top <= 0 ? 1 : Math.round((viewHeight - top) / viewHeight * 100) / 100;
				if ([0, 1].indexOf(percentage) === -1) {
					if (percentage >= 0.75 && lastPercentage < 0.75) {
						// console.log('向下滚动到分界线处', percentage)
						// this.start();
						setTimeout(this.start, 250);
					}
					if (percentage <= 0.75 && lastPercentage > 0.75) {
						// console.log('向上滚动到分界线处', percentage)
						// this.reset();
						setTimeout(this.reset, 250);
					}
				}
				lastPercentage = percentage;
			}, { threshold });
			observer.observe(this.$el);
			// console.clear()
			// console.log(viewHeight, typeHeight)
		} else {
			this.dragging = false;
			this.enableRotate = true;
		}
	},
	methods: {
		start() {
			this.dynamicData = this.getPositionRotation();
			this.animateTo(true, this.leftImageRightText);
		},
		reset() {
			this.dynamicData = this.getPositionRotation();
			this.animateTo(false, this.leftImageRightText);
		},
		onMouse(type, ...events) {
			if (type === 'up') {
				// 鼠标抬起
				this.dragging = false;
				this.dynamicData = this.getPositionRotation();
			}
			if (type === 'down') {
				// 鼠标按下
				this.dragging = true;
			}
		},
		modelLoad() {
			// 初始化记录信息
			this.initialData = Object.freeze(this.getPositionRotation());
			this.dynamicData = JSON.parse(JSON.stringify(this.initialData));
		},
		hoverMove(event) {
			if (this.dragging || this.enableRotate === false) {
				return;
			}
			if (this.mousePosition.x === null && this.mousePosition.y === null) {
				this.mousePosition.x = event.clientX;
				this.mousePosition.y = event.clientY;
				return;
			}
			// 根据鼠标移动的距离计算旋转角度，绕Y轴和X轴旋转模型
			this.dynamicData.objectRotation.x += (event.clientY - this.mousePosition.y) * 0.025 * (Math.PI / 180);
			this.dynamicData.objectRotation.y += (event.clientX - this.mousePosition.x) * 0.025 * (Math.PI / 180);
			// 更新鼠标的最后位置
			this.mousePosition.x = event.clientX;
			this.mousePosition.y = event.clientY;
		},
		animateTo(start = true, lirt = true) {
			// lirt true  左图右文 x -0.5 | y 0.30 | z 0.10
			// lirt false 左文右图 x -0.5 | y -0.3 | z -0.1
			const duration = 1000,
				  interval = 20,
				  total = duration / interval,
				  queue = (start ? [
				{
					name: 'objectRotation',
					list: [
						{ name: 'x', goal: lirt ? -0.5 : -0.5 },
						{ name: 'y', goal: lirt ? 0.30 : -0.3 },
						{ name: 'z', goal: lirt ? 0.10 : -0.1 }
					]
				}
			] : [
				{
					name: 'objectRotation',
					list: [
						{ name: 'x', goal: this.initialData.objectRotation.x },
						{ name: 'y', goal: this.initialData.objectRotation.y },
						{ name: 'z', goal: this.initialData.objectRotation.z }
					]
				},
				{
					name: 'cameraPosition',
					list: [
						{ name: 'x', goal: this.initialData.cameraPosition.x },
						{ name: 'y', goal: this.initialData.cameraPosition.y },
						{ name: 'z', goal: this.initialData.cameraPosition.z }
					]
				},
				{
					name: 'cameraRotation',
					list: [
						{ name: 'x', goal: this.initialData.cameraRotation.x },
						{ name: 'y', goal: this.initialData.cameraRotation.y },
						{ name: 'z', goal: this.initialData.cameraRotation.z }
					]
				}
			]).map(items => {
				items.list = items.list.map(item => {
					item['init'] = this.dynamicData[items.name][item.name]; // 初始值
					item['diff'] = Math.abs(item.init - item.goal); // 差值
					return item;
				}).filter(item => item.diff);
				return items;
			}).filter(items => items.list.length);
			this.dragging = true;
			this.enableRotate = false;
			if (queue.length) {
				let count = 0,
					timer = setInterval(() => {
					count += 1;
					for (let { name: type, list } of queue) {
						for (let { name, init, goal } of list) {
							this.dynamicData[type][name] = this.interpolateValue(init, goal, count, total);
						}
					}
					if (count === total) {
						clearInterval(timer);
						if (start) {
							this.dragging = false;
							this.enableRotate = true;
						}
					}
				}, interval);
			}
		},
		interpolateValue(initValue, goalValue, currentCount, totalCount) {
			// 0 100 0 100
			// 确保currentCount不会超过totalDegree
			currentCount = Math.min(currentCount, totalCount);
			// 计算当前的进度比例
			const progress = currentCount / totalCount;
			// 使用二次函数来调整进度，使得变化先快后慢
			const easeOutProgress = 1 - (1 - progress) * (1 - progress);
			// 计算当前的值
			const currentValue = initValue + (goalValue - initValue) * easeOutProgress;
			return currentValue;
		},
		getPositionRotation() {
			const number = 1000000;
			const object = this.$refs['model'].object;
			const camera = this.$refs['model'].camera;
			const filter = value => Math.round(value * number) / number;
			return {
				objectPosition: { x: filter(object.position.x), y: filter(object.position.y), z: filter(object.position.z) },
				objectRotation: { x: filter(object.rotation.x), y: filter(object.rotation.y), z: filter(object.rotation.z) },
				cameraPosition: { x: filter(camera.position.x), y: filter(camera.position.y), z: filter(camera.position.z) },
				cameraRotation: { x: filter(camera.rotation.x), y: filter(camera.rotation.y), z: filter(camera.rotation.z) }
			};
		}
	},
	computed: {
		hasTdModel() {
			return Boolean(this.showData.threedobject_url);
		},
		mainPicture() {
			return this.showData.photo || '';
		},
		tdModelClass() {
			return this.showData.image ? 'thredD-model-container layout-normal' : 'thredD-model-container layout-sticky';
		},
		controlsOptions() {
			return {
				enableZoom: false,
				enableRotate: this.enableRotate
			};
		},
		leftImageRightText() {
			return this.$options.name === 'type-C';
		}
	},
	components: {
		'vue-3d-loader': vue3dLoader
	}
}